<template>
    <div class="flex items-center">
        <vx-dropdown ref="dropdownRef" :teleport="true">
            <vx-button data-test="open-actions" :disabled="props.disabled"
                color="transparent"
                type="button">
                <font-awesome-icon widthAuto class="text-sm"
                    :icon="faCirclePlus"></font-awesome-icon>
            </vx-button>

            <template v-slot:items>
                <slot></slot>
                <vx-dropdown-item v-if="!props.disableSnippets"
                    data-test="snippets-action"
                    @click.prevent="emit('click:snippets')">
                    <span>
                        <font-awesome-icon widthAuto :icon="faCubes"
                            class="mr-1 text-sm"></font-awesome-icon>
                        Snippets
                    </span>
                </vx-dropdown-item>
                <vx-dropdown-item @click.prevent="emit('click:variables')">
                    <span>
                        <font-awesome-icon widthAuto :icon="faCube"
                            class="mr-1 text-sm"></font-awesome-icon>
                        Variables
                    </span>
                </vx-dropdown-item>
                <vx-popover hover placement="right" arrow class="w-full">
                    <vx-dropdown-item
                        v-if="!props.disableMedia"
                        :disabled="props.blockImages && props.blockFiles"
                        @click.prevent="emit('click:media')"
                    >
                    <span>
                        <font-awesome-icon widthAuto :icon="faImage"
                            class="mr-1 text-sm"></font-awesome-icon>
                        Media
                    </span>

                    </vx-dropdown-item>
                    <template v-if="props.blockImages && props.blockFiles" v-slot:content>Disabled by <strong>corporate.</strong></template>
                </vx-popover>
            </template>
        </vx-dropdown>
        <div class="w-px h-4 bg-slate-200"></div>
        <vx-button @click.prevent="emit('click:emojis')"
            :disabled="props.disabled"
            color="transparent"
            type="button">
            <font-awesome-icon widthAuto class="text-sm"
                :icon="faFaceGrin"></font-awesome-icon>
        </vx-button>
    </div>
</template>

<script setup>
import { faCube, faCubes, faFaceGrin } from '@fortawesome/pro-regular-svg-icons';
import { faCirclePlus, faImage } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton, VxDropdown, VxDropdownItem, VxPopover } from '@voxie/frontend-components';
import { computed, ref } from 'vue';

const props = defineProps({
    disabled: Boolean,
    disableSnippets: Boolean,
    disableMedia: Boolean,
    blockImages: Boolean,
    blockFiles: Boolean,
});

const dropdownRef = ref();
const open = computed(() => {
    if (!dropdownRef.value) {
        return false;
    }

    return dropdownRef.value.open;
})

const emit = defineEmits(['click:variables', 'click:snippets', 'click:emojis', 'click:media'])

defineExpose({
    open: open,
});
</script>
